<template>
  <div class="user-message-container">
    <div class="user-message-content">
      <div class="message-text">{{ content }}</div>
    </div>
    <div class="user-avatar">
      <span>我</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.user-message-container {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  margin-bottom: 4px;
  padding: 4px 0;
}

.user-message-content {
  max-width: 75%;
  margin-right: 12px;
}

.message-text {
  padding: 10px 14px;
  background-color: #2563eb;
  color: #fff;
  border-radius: 12px;
  border-top-right-radius: 2px;
  font-size: 15px;
  line-height: 1.6;
  word-break: break-word;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  animation: fadeIn 0.3s ease;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #10b981;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: white;
  flex-shrink: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
